import type { EventFilter } from "@/Modules/Chat/WebSocketManager";
import type { BotUcsCodeWebSocket } from "@/Modules/Chat/Models/WebSocket";

import { MessageTypeWebSocket } from "@/Modules/Chat/Models/WebSocket";
import { usePlanStore, type PlanStore } from "@/Modules/Plan/Store";

import { isObject } from "@/Utils/Objects";

export interface ExtraParamsUcsCodeStatus {
  planStore: PlanStore;
}

export const isUcsCodeStatus = (value: unknown): value is BotUcsCodeWebSocket => {
  return isObject(value) && value.type === MessageTypeWebSocket.UCS_CODE;
};

export const botUcsCodeStatusHandler = async (
  _message: unknown,
  { planStore = usePlanStore() }: ExtraParamsUcsCodeStatus
): Promise<undefined> => {
  await planStore.fetchPlans(false, false);

  return undefined;
};

export default {
  isType: isUcsCodeStatus,
  handler: botUcsCodeStatusHandler,
} as EventFilter<ExtraParamsUcsCodeStatus>;
